import {AxiosPromise} from "axios";
import {request} from "../../common/utils/apiHelpers";

export const requestMenuSync = (companyId: number): AxiosPromise =>
  request(
    `/company/${companyId}/request-menu-sync`,
    'POST',
  )
